import { render, staticRenderFns } from "./FinalPromptScreen.vue?vue&type=template&id=52b1919c"
import script from "./FinalPromptScreen.vue?vue&type=script&lang=js"
export * from "./FinalPromptScreen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports